
import { Component, Vue } from "vue-property-decorator";
import TakeTongue from "@/components/TakeTongue.vue";
import AskQuestion from "@/components/AskQuestion.vue";
import TipCarousel from "@/components/TipCarousel.vue";
import { GetFinalReport } from "@/request/common";

@Component({
  components: {
    TakeTongue,
    AskQuestion,
    TipCarousel,
  },
})
export default class Caiji extends Vue {
  private currentStep: "takeTongue" | "askQuestion" = "takeTongue";
  private textAudio: any = "";
  private basicInfo: any = {};
  private data: any = {
    imgUrl: "",
    algo_result: {},
    deepseek_result: "",
    extra_text: "",
    report: {},
  };
  private data1: any = {
    imgUrl:
      "https://zydata.oss-cn-shanghai.aliyuncs.com/cy/jiaoxue/file/test/file/2e2179b5f027423f962b1c71789210cc_125322.jpg",
    // imgUrl: "http://zydata.oss-cn-shanghai.aliyuncs.com/cy/files/tongue_ffcda5b1-1fff-455f-9015-001f313bc24b.jpg",
    algo_result: {
      result_dict: {
        舌象照片: {
          分割前图片:
            "https://gyhl.oss-cn-shanghai.aliyuncs.com/tongue-ai/a7ed2d01-fc97-4141-a944-26be437248bd_crop.jpg",
          分割后图片:
            "https://gyhl.oss-cn-shanghai.aliyuncs.com/tongue-ai/a7ed2d01-fc97-4141-a944-26be437248bd_segment.jpg",
        },
        舌色参数: [
          [56.4, 57.06, 54.76, 57.12, 56.19, 56.87],
          [19.63, 19.89, 18.28, 19.61, 19.56, 20.82],
          [7.37, 6.53, 8.01, 7.72, 7.87, 6.74],
          ["淡紫", "", "", "", "", ""],
        ],
        苔色参数: [
          [57.8, 58.47, 56.52, 58.91, 57.88, 57.23],
          [19.22, 20.17, 17.89, 19.23, 19.02, 19.77],
          [7.69, 7.33, 7.97, 8.21, 8.12, 6.82],
          ["苔黄", "", "", "", "", ""],
        ],
        舌象信息输出: [
          "淡紫",
          "有",
          "有",
          "苔黄",
          "厚",
          "有",
          "无",
          "无",
          "适中",
          "无",
          "有",
          "有",
        ],
      },
      result_text:
        "\n    舌色：淡紫，边尖红：有，瘀斑瘀点：有，\n    苔色：苔黄，苔厚薄：厚，苔腻：有，苔腐：无，苔剥：无，\n    舌胖瘦：适中，齿痕：无，点刺：有，裂纹：有\n    ",
    },
    deepseek_result:
      "从您的舌象来看，舌色淡紫伴有瘀斑瘀点，提示可能存在气血运行不畅或血瘀的情况；苔黄厚腻则表明体内有湿热积聚。此外，舌面点刺和裂纹也提示可能存在内热或阴液不足。为了更好地了解您的整体状况，您可以点击下方按钮，自由分享其他可能的症状或感受，我将为您提供更全面的建议。",
    extra_text: "最近经常头晕，乏力。",
    report: {
      中医体质辨识结果: "湿热瘀阻型",
      中医证型辨识结果: "湿热瘀阻证",
      症状解析: {
        常见表现:
          "患者舌色淡紫，边尖红，伴有瘀斑瘀点，提示气血运行不畅或血瘀；苔黄厚腻，表明体内有湿热积聚；舌面点刺和裂纹，提示内热或阴液不足。此外，患者最近经常头晕、乏力，可能与湿热内蕴、气血运行不畅有关。",
        发病倾向:
          "湿热瘀阻型体质的人群，容易出现头晕、乏力、胸闷、口苦、口干、便秘或腹泻等症状。长期湿热内蕴可能导致肝胆疾病、心血管疾病、皮肤病等。",
      },
      调理方案: {
        四季养生: [
          {
            name: "春季养生",
            content:
              "春季应注重疏肝理气，避免情绪波动过大。建议多进行户外活动，如散步、踏青，以促进气血运行。饮食上宜清淡，多吃新鲜蔬菜和水果，如菠菜、芹菜、苹果等，避免油腻和辛辣食物。",
          },
          {
            name: "夏季养生",
            content:
              "夏季湿热较重，应注重清热利湿。建议多喝水，保持室内通风，避免长时间暴露在高温环境中。饮食上宜清淡，多吃冬瓜、黄瓜、绿豆等清热利湿的食物，避免生冷和油腻食物。",
          },
          {
            name: "秋季养生",
            content:
              "秋季应注重润肺养阴，避免干燥。建议多进行户外活动，如慢跑、太极拳，以增强体质。饮食上宜多吃滋阴润燥的食物，如梨、百合、银耳等，避免辛辣和燥热食物。",
          },
          {
            name: "冬季养生",
            content:
              "冬季应注重温阳补肾，避免寒邪侵袭。建议多进行室内活动，如瑜伽、气功，以增强体质。饮食上宜多吃温补食物，如羊肉、核桃、黑芝麻等，避免生冷和寒凉食物。",
          },
        ],
        体育锻炼: [
          {
            name: "太极拳",
            content:
              "太极拳是一种温和的全身运动，有助于调节气血运行，改善湿热瘀阻体质。建议每天练习30分钟，注意呼吸均匀，动作缓慢。",
          },
          {
            name: "瑜伽",
            content:
              "瑜伽有助于调节身心，改善湿热瘀阻体质。建议每周练习3-4次，每次30-60分钟，注意呼吸和动作的协调。",
          },
          {
            name: "散步",
            content:
              "散步是一种低强度的有氧运动，有助于促进气血运行，改善湿热瘀阻体质。建议每天散步30分钟，保持轻松的步伐。",
          },
        ],
        起居调摄: [
          {
            name: "保持室内通风",
            content:
              "保持室内空气流通，有助于减少湿热积聚。建议每天开窗通风2-3次，每次30分钟。",
          },
          {
            name: "避免熬夜",
            content:
              "熬夜会加重湿热内蕴，建议每天保持7-8小时的睡眠，避免熬夜。",
          },
          {
            name: "保持心情舒畅",
            content:
              "情绪波动过大会影响气血运行，建议保持心情舒畅，避免过度焦虑和紧张。",
          },
        ],
        音乐调理: [
          {
            name: "古典音乐",
            content:
              "古典音乐有助于放松身心，改善湿热瘀阻体质。建议每天听30分钟，如贝多芬的《月光奏鸣曲》、莫扎特的《小夜曲》等。",
          },
          {
            name: "自然音乐",
            content:
              "自然音乐有助于调节情绪，改善湿热瘀阻体质。建议每天听30分钟，如流水声、鸟鸣声等。",
          },
          {
            name: "冥想音乐",
            content:
              "冥想音乐有助于放松身心，改善湿热瘀阻体质。建议每天听30分钟，如《禅意》、《静心》等。",
          },
        ],
        经络保健: [
          {
            name: "按摩足三里穴",
            content:
              "足三里穴是健脾和胃的重要穴位，有助于改善湿热瘀阻体质。建议每天按摩5-10分钟，力度适中。",
          },
          {
            name: "按摩三阴交穴",
            content:
              "三阴交穴是调节肝脾肾的重要穴位，有助于改善湿热瘀阻体质。建议每天按摩5-10分钟，力度适中。",
          },
          {
            name: "按摩太冲穴",
            content:
              "太冲穴是疏肝理气的重要穴位，有助于改善湿热瘀阻体质。建议每天按摩5-10分钟，力度适中。",
          },
        ],
        用药禁忌: [
          {
            name: "避免使用温热药物",
            content:
              "湿热瘀阻体质的人群应避免使用温热药物，如人参、黄芪等，以免加重湿热内蕴。",
          },
          {
            name: "避免使用寒凉药物",
            content:
              "湿热瘀阻体质的人群应避免使用寒凉药物，如黄连、黄芩等，以免损伤脾胃。",
          },
          {
            name: "避免使用滋腻药物",
            content:
              "湿热瘀阻体质的人群应避免使用滋腻药物，如熟地、阿胶等，以免加重湿热内蕴。",
          },
        ],
        推荐食疗: [
          {
            name: "冬瓜薏米汤",
            content:
              "配方：冬瓜500克，薏米50克，瘦肉100克。功效：清热利湿，健脾和胃。适用于湿热瘀阻体质的人群。",
          },
          {
            name: "绿豆百合粥",
            content:
              "配方：绿豆50克，百合30克，大米100克。功效：清热利湿，润肺养阴。适用于湿热瘀阻体质的人群。",
          },
          {
            name: "芹菜炒木耳",
            content:
              "配方：芹菜200克，木耳50克，瘦肉100克。功效：清热利湿，活血化瘀。适用于湿热瘀阻体质的人群。",
          },
        ],
      },
    },
  };
  private ifShowTip = false;

  private async handleTongueUploadSuccess(data: string) {
    this.data = data;
    // 生成语音文件播放
    this.textAudio = new Audio(this.data.sheAudioUrl);
    this.textAudio.play();
    // 4. 监听播放结束事件
    this.textAudio.addEventListener("ended", () => {
      this.textAudio = null; // 清空 currentAudio
    });

    this.currentStep = "askQuestion";
  }
  private stopAudio() {
    this.textAudio.pause();
    this.textAudio = null; // 清空 currentAudio
  }
  private goTakeTongue() {
    this.data = {
      imgUrl: "",
      algo_result: {},
      deepseek_result: "",
      extra_text: "",
      report: {},
    };
    if (this.textAudio) {
      this.stopAudio();
    }
    this.currentStep = "takeTongue";
  }
  private async handleAudioSubmit(text: string) {
    this.data.extra_text = text;
    this.data.basicInfo = this.basicInfo;
    this.ifShowTip = true;

    // 获取报告
    try {
      // 显示加载状态
      // const loading = this.$toast.loading({
      //   message: '生成报告中...',
      //   forbidClick: true,
      //   duration: 0
      // });

      // 准备报告数据
      let reportData: any = JSON.parse(JSON.stringify(this.data));

      // 必填基础信息
      reportData.gender = reportData.basicInfo.gender;
      reportData.age_group = reportData.basicInfo.age;
      reportData.weight_group = reportData.basicInfo.weight;
      reportData.client_id = this.$store.state.clientInfo.id;

      // 可选基础信息：姓名、证件号、证件类型、出生日期、手机号
      // 如果后端字段是可选的，可以为空字符串或不传，这里统一传空字符串以保持字段存在
      reportData.name = reportData.basicInfo.name || "";
      reportData.id_code = reportData.basicInfo.id_code || "";
      reportData.id_code_type = reportData.basicInfo.id_code_type || "";
      reportData.birth_date = reportData.basicInfo.birth_date || "";
      reportData.phone = reportData.basicInfo.phone || "";

      // 调用GetFinalReport获取report_id
      const res = await GetFinalReport(this, reportData);

      // 关闭加载状态
      // loading.clear();
      this.ifShowTip = false;

      // 获取到report_id后跳转到report页面
      const reportId = res.report_id;
      console.log("获取到report_id:", reportId);

      this.$router.push({
        path: "/report",
        query: {
          report_id: reportId,
          ifCanReturn: "true",
        },
      });
    } catch (error) {
      // 关闭加载状态
      this.$toast.clear();
      console.error("获取报告失败:", error);
      this.$toast.fail("生成报告失败，请重试");
    }
  }
  private mounted() {
    this.basicInfo = this.$route.query;
  }
}
